const mapsLink = 'https://www.google.com/maps/place/Av.+Apoquindo+4660,+Las+Condes,+Regi%C3%B3n+Metropolitana,+Chile/@-33.4124645,-70.5832489,17z/data=!3m1!4b1!4m5!3m4!1s0x9662cf220e058827:0xb5ca3afbfd2b9c82!8m2!3d-33.4124645!4d-70.5810602';
const linkedinLink = 'https://www.linkedin.com/company/fingomas/';
const instagramLink = 'https://www.instagram.com/___fingo/';
const whatsappLink = 'https://api.whatsapp.com/send?phone=15559641138&text=Hola%20buenos%20d%C3%ADas!%20%F0%9F%91%8B';
const FINGO_CL_LANDING_LINK = 'https://fingo.cl';
const FINGO_MX_LANDING_LINK = 'https://fingo.cl';

export { FINGO_CL_LANDING_LINK, FINGO_MX_LANDING_LINK, mapsLink, linkedinLink, instagramLink, whatsappLink };
